export default __webpack_public_path__ + "static/DSC_0429-9f28a4de9ee443cbe996046524e80495.jpg";